/** Taunt / emote lines shown in speech bubbles (press T). */
export const EMOTE_LINES = [
  "Can't we just talk it out?",
  "Yer dead!",
  "Reach for it!",
  "No cheatin!",
  "This town ain't big enough!",
  "Draw, pardner!",
  "I ain't scared of you!",
  "Say yer prayers!",
  "Easy now…",
  "You first!",
  "I didn't sign up for this...",
  "Somethin' about huckleberry!",
  "I'm outta here!",
  "Thanks for playing Cowboy Countdown!",
  "I'm tellin' my pappy!",
  "YEEEEEEEEEEEEEEEEEHAWWWW!",
] as const;

/** How long a speech bubble stays up (ms). */
export const EMOTE_DURATION_MS = 2000;
/** Minimum time between local emotes (ms). */
export const EMOTE_COOLDOWN_MS = 1200;

export function randomEmoteLine(): string {
  return EMOTE_LINES[Math.floor(Math.random() * EMOTE_LINES.length)]!;
}
